import { PageTypes } from '@core/constants/pages'
import { querySettings } from '@core/app/pages/query-settings'
import { queryPage } from '@core/app/pages/query-page'
import { processParams } from '@core/app/pages/currency/params'
import { getPageView } from '@core/analytics/pages'

export default async function loadPageData() {
  const route = useRoute()
  const nuxtApp = useNuxtApp()

  const { data, error } = await useAsyncData(`pageData:${route.path}`, async () => {
    const { slug, pattern, currencyFrom, currencyTo } = processParams(route.params)
    const [{ navigation, footer, footerContent }, { body, page }] = await Promise.all([
      querySettings(nuxtApp),
      queryPage(nuxtApp, slug, pattern),
    ])

    return {
      navigation,
      footer,
      body: [...body, ...(footerContent ?? [])],
      page,
      currencyFrom,
      currencyTo,
    }
  })

  if (!data.value) {
    throw createAsyncDataError(error)
  }

  if (import.meta.client) {
    const { page, currencyFrom, currencyTo } = data.value
    await nuxtApp.$track(
      getPageView(route, {
        type: PageTypes.CURRENCY,
        page: { tags: page.tags || [], context: page.context },
        currencies: { currencyFrom, currencyTo },
      }),
    )
  }

  return data.value
}
